import {Options, TableColumn} from '@fl/cmsch-fe-library';

import {StableToChoose} from 'api/gen/StableToChoose';
import {getCalfTableLink} from 'app/animal-browser/utils/get-calf-table-link';
import {getCowTableLink} from 'app/animal-browser/utils/get-cow-table-link';
import {TFunction} from 'app/translations';

/**
 * Builds the column configuration for the stable overview table.
 *
 * @param productionAreas Production-area options used by the filterable column.
 * @param t Animal-browser translation helper.
 * @returns The stable-overview table columns.
 */
/* eslint-disable max-lines-per-function */
export const farmStablesColumns = (
    productionAreas: Options<string>,
    t: TFunction<'animalBrowser'>,
): Array<TableColumn<StableToChoose>> => [
    {
        field: 'breederRegistrationNumber',
        type: 'number',
        formatValue: String,
    },
    {
        field: 'breederName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'farmCode',
        type: 'router',
        linkTooltip: t('showCalvesOverview'),
        valueToLink: getCalfTableLink,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'farmName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'stableCode',
        type: 'router',
        linkTooltip: t('showCowsOverview'),
        valueToLink: getCowTableLink,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'stableName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'stableInStudbookRegistry',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString'],
    },
    {
        field: 'proficiencyTest',
        type: 'optionalBoolean',
        filterTypes: ['null'],
    },
    {
        field: 'productionArea',
        type: 'option',
        options: productionAreas,
        filterTypes: [{type: 'multiSelectStringOrEquals', subtype: 'defaultMultiSelectString'}, 'null'],
        customFiltersOnly: true,
    },
    {
        field: 'organizationCode',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'farmAnimalCount',
        type: 'number',
        filterTypes: ['null'],
    },
    {
        field: 'stableAnimalCount',
        type: 'number',
        filterTypes: ['null'],
    },
];
/* eslint-enable max-lines-per-function */
